import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    boxContainer: {
        width: "100%",
    },
    formContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: theme.spacing(6),
    },
    formLabel: {
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            textTransform: "uppercase",
            color: theme.palette.primary.dark,
        },
        "&.MuiFormLabel-root.Mui-focused": {
            color: theme.palette.primary.dark,
        },
    },
    checkbox: {
        "&.MuiCheckbox-root": {
            color: theme.palette.corporateBO.checkbox,
            "&.Mui-checked": {
                color: theme.palette.info.main,
            },
        },
    },
    textField: {
        width: "100%",
        height: 56,
        "& .MuiOutlinedInput-root": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.MuiOutlinedInput-input": {
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontWeight: "400",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.info.main,
            },
        },
        "& .MuiInputLabel-outlined": {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            "&.Mui-focused": {
                color: theme.palette.info.light,
            },
        },
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            background: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "14px",
            borderBottom: "1px solid rgba(193, 200, 218, 1)",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Open Sans",
            paddingBottom: "5px",
        },
    },
    buttonsContainer: {
        width: "100%",
        borderTop: `1px solid ${theme.palette.corporateBO.lineSeparator}`,
        padding: "15px 30px",
        display: "flex",
        justifyContent: "flex-end",
    },
    addButton: {
        "&.MuiButton-root": {
            background: theme.palette.info.main,
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.main,
            marginLeft: "15px",
        },
        "&.MuiButton-root:hover": {
            background: theme.palette.info.main,
        },
    },
    cancelButton: {
        "&.MuiButtonBase-root": {
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "12px",
            color: theme.palette.primary.dark,
        },
    },
    setupMillLink: {
        fontWeight: "bold",
        textDecoration: "underline",
        cursor: "pointer",
    },
    menuItem: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between !important",
        gap: 4,
        fontSize: `14px !important`,
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.secondary.main} !important`,
        },
    },
    box: {
        display: "flex !important",
        flexWrap: "wrap",
        gap: 2,
    },
    modalBody: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: theme.spacing(6),
        padding: "20px 30px 0",
    },
    footer: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        display: "flex",
        padding: `${theme.spacing(4)} ${theme.spacing(6)}`,
        gap: theme.spacing(4),
        justifyContent: "flex-end",
        width: "100%",
    },
    button: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
            color: `${theme.palette.primary.dark} !important`,
        },
    },
    submitButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    deleteButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
            background: `${theme.palette.error.main} !important`,
        },
    },
    machineCenterInputLabel: {
        display: "flex !important",
        alignItems: "center",
        justifyContent: "space-between",
    },
    maxMachineCenterAmountLegend: {
        fontSize: "12px !important",
    },
    error: {
        color: `${theme.palette.error.main} !important`,
        marginTop: `${theme.spacing(0.8)} !important`,
        marginLeft: `${theme.spacing(3)} !important`,
    },
    clusterChip: {
        background: `${theme.palette.error.light} !important`,
        color: `${theme.palette.primary.main} !important`,
    },
}));
